// @flow

export class InvalidSignatureError extends Error {}
